import React from 'react';
import axiosInstance from '../services/axiosComman';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

function useDeleteData() {
  const handleDelete = async ({ url = "", id = "", value = "", fetcher = () => {}, data = "" }) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to Delete ${value}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const config = data ? { data } : {};
          const response = await axiosInstance.delete(url, config);

          const successMessage = response.data.msg || response.data.message || "Data deleted successfully";
          const isSuccess = response.data.status || successMessage === "Data Deleted Successfully";

          if (isSuccess) {
            fetcher();
            toast.success(<p className="text-sm">{successMessage}</p>);
          } else {
            const errorMessage = response.data.msg || response.data.message || "Failed to delete data";
            toast.error(<p className="text-sm">{errorMessage}</p>);
          }
        } catch (error) {
          if (!error.response) {
            toast.error(
              <p className="text-sm">
                {`CORS Error: Unable to connect to the server. Please check server CORS settings.`}
              </p>
            );
          } else {
            const errorMessage =
              error.response.data?.msg ||
              error.response.data?.message ||
              error.response.data?.error ||
              "An unexpected error occurred";
            toast.error(<p className="text-sm">{errorMessage}</p>);
          }
        }
      }
    });
  };

  return { handleDelete };
}

export default useDeleteData;
